/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActiveKioskConfigDto } from '../../models/active-kiosk-config-dto';

export interface KioskConfigControllerGetActiveV1$Params {
}

export function kioskConfigControllerGetActiveV1(http: HttpClient, rootUrl: string, params?: KioskConfigControllerGetActiveV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ActiveKioskConfigDto>> {
  const rb = new RequestBuilder(rootUrl, kioskConfigControllerGetActiveV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ActiveKioskConfigDto>;
    })
  );
}

kioskConfigControllerGetActiveV1.PATH = '/api/v1/kiosk-config/active';
